export enum ExperimentFlags {
  EXPERIMENT_USE_DISCOVERY_JOURNEY = "experiment-use-discovery-journey",
  GUEST_PRICE_V3 = "page-experiment-guest-price-v3",
  OOS_SIMILAR_TO_EXPERIMENT = "page-experiment-show-similar-to",
  PAGE_EXPERIMENT_CLOUDINARY_LOADER = "page-experiment-cloudinary-loader",
  PAGE_EXPERIMENT_CONSTRUCTOR_BROWSE = "page-experiment-constructor-browse",
  PAGE_EXPERIMENT_CONTENT_FOR_DISCOVERY_JOURNEY = "page-experiment-test-discovery-journey",
  PAGE_EXPERIMENT_OPENGATE = "page-experiment-opengate",
  PAGE_EXPERIMENT_PDP_WITH_OPEN_GATE_UI = "page-experiment-pdp-with-open-gate-ui",
  PAGE_EXPERIMENT_US_JOURNEY = "page-experiment-us-journey",
  PRODUCT_COMPARISON_EXPERIMENT_V3 = "experiment-product-comparison-v3",
  SHOW_ORDER_IT_AGAIN_PAGE = "show-favourites-order-it-again",
  USE_ATBL_V2 = "use-atbl-v2",
  USE_BLOG_MINIFIED_DATA = "use-blog-minified-data",
  USE_FREE_SHIPPING_THRESHOLD = "experiment-use-free-shipping",
  USE_MEMBER_BENEFITS_PAGE = "experiment-use-member-benefits",
  USE_PROMO_CODE_EXPERIMENT = "use-promo-code-experiment",
  PAGE_EXPERIMENT_HIGHLIGHT_NAV_ITEM = "page-experiment-highlight-nav-item",
  PAGE_EXPERIMENT_FOR_YOU_RECOMMENDATIONS_MHP = "page-experiment-for-you-recommendations-mhp",
  USE_NEW_WISHLIST_DESIGN = "use-new-wishlist-design",
  PAGE_EXPERIMENT_PRODUCT_FIRST_PLUS = "page-experiment-product-first-plus",
  PAGE_EXPERIMENT_PRODUCT_FIRST_MINI = "page-experiment-product-first-mini",
  PAGE_EXPERIMENT_NEW_OG_MAPPING = "page-experiment-new-og-mapping",
  PAGE_EXPERIMENT_HIDE_BLACK_BANNER = "page-experiment-hide-black-banner",
  SHOW_OIA_ON_SEARCH = "experiment-oia-on-search",
  SHOW_DIGIOH_POPUP = "show-digioh-popup",
  SHOW_ANNIVERSARY_GIFT_TEASER = "experiment-anniversary-gift-teaser",
  PAGE_EXPERIMENT_AUTOPLAY_VIDEO = "page-experiment-autoplay-video",
  SHOW_MEMBER_TENURE_FROM_UPS = "show-member-tenure",
  PAGE_EXPERIMENT_PEARL = "page-experiment-pearl",
  USE_MEMBER_MANAGEMENT_FLOW_V2 = "use-member-management-flow-v2",
  PAGE_EXPERIMENT_QUIZ_V9 = "page-experiment-quiz-v9",
  PAGE_EXPERIMENT_GUEST_CHECKOUT = "page-experiment-guest-checkout",
  PAGE_EXPERIMENT_FREE_TRIAL_2 = "page-experiment-free-trial-2",
  EXPERIMENT_QUIZ_MODEL_V2 = "experiment-quiz-model-v2",
  EXPERIMENT_SAVE_JOURNEY_PLUS = "experiment-plus-save-journey"
}

export const PAGE_EXPERIMENT_OPENGATE = {
  name: "page-experiment-opengate",
  values: {
    CONTROL: 0,
    THROWAWAY: 1,
    PLUS: 2,
    MINI: 3,
    PLUS_TAB: 4,
    MINI_TAB: 5
  }
};

export const PAGE_EXPERIMENT_PDP_WITH_OPEN_GATE_UI = {
  name: "page-experiment-pdp-with-open-gate-ui",
  values: {
    CONTROL: 0,
    VARIANT: 1,
    THROWAWAY_CONTROL: 2,
    THROWAWAY_VARIANT: 3
  }
};

export const PAGE_EXPERIMENT_GUEST_CHECKOUT = {
  name: "page-experiment-guest-checkout",
  values: {
    NO_FLAG: -1,
    CONTROL: 0,
    VARIANT: 1
  }
};
